import text from '../../constants/js/text.js';
import textSizes from '../../constants/js/text-sizes.js';
export const textSizeStyles = (size) => `
	font-size: ${textSizes[size].fontSize};
	line-height: ${textSizes[size].lineHeight};
`;
export const textWeightStyles = (value) => {
    return `font-weight: ${text[`textWeight${value.charAt(0).toUpperCase()}${value.slice(1)}`]};`;
};
